onReady(() => {
    dataLayer.push({
        'event': 'impact-app-cookies',
        ...window.appValues,
    });
    if (window.zaraz) {
        window.zaraz.set('impact_custom_country', window.appValues.custom_country)
        window.zaraz.set('impact_custom_rating', window.appValues.custom_rating)
        window.zaraz.set('impact_user_status', window.appValues.user_status)
    }
})
